// utils/auth/e_roles.ts - aligné sur monorg-api/server/types/enums/e_role.ts
export enum ERole {
  SUPER_ADMIN = 'YYX_SUPER-ADMIN',
  ADMIN = 'YYX_ADMIN',
  DEVELOPER = 'YYX_DEVELOPPEUR',
  MANAGER = 'YYX_MANAGER',
  CONSULTATION = '',
}

const DEFAULT_ROLE = ERole.CONSULTATION

const PRIMARY_ROLE_PRIORITY: ERole[] = [
  ERole.SUPER_ADMIN,
  ERole.ADMIN,
  ERole.MANAGER,
  ERole.DEVELOPER,
]

/** Profil Gardian tel quel, après trim et passage en majuscules. Le super-admin est `YYX_SUPER-ADMIN`. */
export function canonicalGardianProfile(raw: string): string {
  return raw.trim().toUpperCase()
}

/**
 * Un seul rôle Gardian, forcément préfixé `YYX`.
 */
export function normalizeGardianSesameProfil(raw: unknown): string[] {
  const values = Array.isArray(raw) ? raw : [raw]
  for (const value of values) {
    if (typeof value !== 'string') {
      continue
    }
    const profile = canonicalGardianProfile(value)
    if (profile.startsWith('YYX')) {
      return [profile]
    }
  }
  return []
}

/**
 * Rôle « principal » pour habilitation / orientation UI, à partir des profils OIDC effectifs
 * (aligné sur monorg-api `derivePrimaryHabilitation`).
 */
export function derivePrimaryHabilitation(profiles: string[]): ERole {
  const canonical = profiles.map(canonicalGardianProfile)
  for (const candidate of PRIMARY_ROLE_PRIORITY) {
    if (canonical.includes(candidate)) {
      return candidate
    }
  }
  return DEFAULT_ROLE
}
